import { Helmet } from "react-helmet";

const SITE_NAME = "NearbyGuide";
const SITE_URL = "https://nearbyguide.in";
const DEFAULT_IMAGE = `${SITE_URL}/images/og-home.png`;

const SEO = ({
  title,
  description,
  key,
  canonical,
  image,
  noIndex = false,
  children,
}) => {
  const seoTitle = title || SITE_NAME;
  const seokey =
    key ||
    "nearby places, places near me, nearby places guide, local places near me, best places near me, city guide india, city wise places, local places finder, nearby services, nearby attractions, tourist places near me, temples near me, mandir near me, hospitals near me, medical store near me, restaurants near me, cafes near me, shopping malls near me, parks near me, water park near me, fun places near me, things to do near me, places to visit near me, nearby locations, local discovery platform, find nearby places, explore nearby places, india city guide, NearbyGuide";

  const seoDescription =
    description ||
    "Discover trusted nearby places including temples, hospitals, schools, restaurants, malls and more with NearbyGuide.";

  const seoCanonical = canonical || SITE_URL;
  const seoImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      {/* BASIC */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seokey} />

      {/* ROBOTS */}
      <meta
        name="robots"
        content={noIndex ? "noindex, nofollow" : "index, follow"}
      />

      {/* CANONICAL */}
      <link rel="canonical" href={seoCanonical} />

      {/* OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:url" content={seoCanonical} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      {/* TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />

      {children}
    </Helmet>
  );
};

export default SEO;
